<template>
  <div>
    <ToolbarAuth :name="'Sturen op resultaat'" />
    <div class="ma-0 pa-0">
      <v-row no-gutters>
        <v-col
          cols="12"
          md="6"
          class="leftPanel justify-center"
          :class="{ 'full-page': $vuetify.breakpoint.mdAndUp }"
        >
          <div class="ma-10">
            <div v-if="formal">
              <text-left
                :head-text="textIntro[3].header"
                :text-a="textIntro[3].texta"
                :text-b="textIntro[3].textb"
              />
            </div>
            <div v-if="!formal">
              <text-left
                :head-text="textIntro[3].headerInf"
                :text-a="textIntro[3].textaInf"
                :text-b="textIntro[3].textbInf"
              />
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="6" class="rightPanel justify-center">
          <div class="ma-10">
            <step-text
              :stepText="textIntro[3].header"
              :number="3"
              class="mb-5"
              :active="true"
            />
            <ValidationObserver v-slot="{ invalid }">
              <form ref="form">
                <CustomDivider />
                <div v-if="formal">
                  <StatementText :statement="textIntro[3].textb" />
                </div>
                <div v-if="!formal">
                  <StatementText :statement="textIntro[3].textbInf" />
                </div>
                <base-check
                  v-model="cb_e"
                  label="Financieel, zoals de ontwikkeling van omzet, bedrijfskosten, bedrijfsresultaat, etc."
                />
                <base-check
                  v-model="cb_f"
                  label="Personeel, zoals ontwikkeling personeelskosten en ziekteverzuim:"
                />
                <base-check
                  v-model="cb_g"
                  label="Processen, zoals ontwikkeling fabricagekosten, bezettingsgraad machines, etc."
                />
                <base-check
                  v-model="cb_h"
                  label="Verkoop, zoals aantal uitgebrachte en gewonnen offertes, declarabiliteit, verkochte producten of diensten, aantal nieuwe klanten, omzet per tafel of per vierkante meter, omzet per klant"
                />
                <base-check v-model="cb_i" label="Anders, nl:" />

                <div v-if="cb_i">
                  <base-val-area
                    :textA="'Anders, nl:'"
                    :rules="'max:200'"
                    :label="'Anders'"
                    v-model="text_c"
                  />
                </div>
                <CustomDivider />
                <v-row class="mt-10">
                  <v-spacer />
                  <btn-back :onClick="backStep" />
                  <btn-continue :onClick="nextStep" :disabled="invalid" />
                </v-row>
              </form>
            </ValidationObserver>
            <div class="mt-10" />
            <step-text
              :stepText="textIntro[4].header"
              :number="4"
              class="mb-5"
              :active="false"
            />
            <step-text
              :stepText="textIntro[5].header"
              :number="5"
              class="mb-5"
              :active="false"
            />
            <step-text
              :stepText="textIntro[6].header"
              :number="6"
              class="mb-5"
              :active="false"
            />
            <step-text
              :stepText="textIntro[7].header"
              :number="7"
              class="mb-5"
              :active="false"
            />
            <step-text
              :stepText="textIntro[8].header"
              :number="8"
              class="mb-5"
              :active="false"
            />
            <step-text
              :stepText="textIntro[9].header"
              :number="9"
              class="mb-5"
              :active="false"
            />
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import textData from "@/text/textApp.json";

export default {
  name: "stepThree",
  components: {},
  data() {
    return {
      textIntro: textData,
      formal: null,
    };
  },
  computed: {
    cb_e: {
      get() {
        return this.$store.state.quick.cb_e;
      },
      set(value) {
        this.$store.commit("quick/update_cb_e", value);
      },
    },
    cb_f: {
      get() {
        return this.$store.state.quick.cb_f;
      },
      set(value) {
        this.$store.commit("quick/update_cb_f", value);
      },
    },
    cb_g: {
      get() {
        return this.$store.state.quick.cb_g;
      },
      set(value) {
        this.$store.commit("quick/update_cb_g", value);
      },
    },
    cb_h: {
      get() {
        return this.$store.state.quick.cb_h;
      },
      set(value) {
        this.$store.commit("quick/update_cb_h", value);
      },
    },
    cb_i: {
      get() {
        return this.$store.state.quick.cb_i;
      },
      set(value) {
        this.$store.commit("quick/update_cb_i", value);
      },
    },
    text_c: {
      get() {
        return this.$store.state.quick.text_c;
      },
      set(value) {
        this.$store.commit("quick/update_text_c", value);
      },
    },
  },
  methods: {
    nextStep() {
      this.$router.push({ name: "stepFour" });
    },
    backStep() {
      this.$router.push({ name: "stepTwo" });
    },
  },

  mounted() {
    this.formal = JSON.parse(localStorage.getItem("formal"));
  },
};
</script>
